import React from "react"
import {Link} from "react-router-dom"
import {getPathBack} from "../functions"
import {Button} from "react-bootstrap"

export class UpdateUserClass extends React.Component {

    render() {

        const {user, content, lang, sendEmail} = this.props
        console.log(user, content)

        const changeHandler = (event) => {
            console.log(event.target.value)
        }

        return (
            <>
                <div className={'container m-auto w-100'}>
                    <div className={'mb-2 col d-flex flex-nowrap justify-content-start'}>
                        {<Link id={'to-back'}
                               to={getPathBack()}
                               type={'button'}
                               className={'col col-md-2 col-lg-2 col-sm-3 col-2 btn btn-info m-1 fs-5 p-sm-1 p-2 d-flex align-items-center justify-content-center fw-bold'}>
                            <i className={'fa-solid fa-arrow-left'}/>
                        </Link>}
                    </div>
                </div>
                <div className={'container m-auto w-50'}>
                    <div id={"divEmail"} className={"mb-3"}>
                        <label
                            htmlFor={"email"}
                            className={"ms-2 ps-1 form-label"}>
                            {lang.body.authPage.labelEmail}
                        </label>
                        <div className={'d-flex flex-nowrap'}>
                            <input
                                type={"text"}
                                name={"email"}
                                id={"email"}
                                onChange={changeHandler}
                                className={"form-control"}
                                placeholder={'Введите email пользователя'}
                            />
                            <Button
                                className={'ms-2 btn btn-success'}
                                onClick={() => {
                                    sendEmail(document.querySelector('#email').value)
                                }}>
                                {'Отправить'}
                            </Button>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}